import { render } from "./FeedbackTab.vue?vue&type=template&id=fee879c8"
import script from "./FeedbackTab.vue?vue&type=script&lang=js"
export * from "./FeedbackTab.vue?vue&type=script&lang=js"

import "./FeedbackTab.vue?vue&type=style&index=0&id=fee879c8&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fee879c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fee879c8', script)) {
    api.reload('fee879c8', script)
  }
  
  module.hot.accept("./FeedbackTab.vue?vue&type=template&id=fee879c8", () => {
    api.rerender('fee879c8', render)
  })

}

script.__file = "src/components/recreation/tabs/FeedbackTab.vue"

export default script